import styled, { css } from "styled-components";
import { cssReset, flexCenter } from "../../mixins/style-mixins";
import { IconWrapperProps } from "./IconWrapper.types";
import { getSizeInRem } from "../../methods/common";
export const StyledIconWrapper = styled.div<Partial<IconWrapperProps>>`
    ${cssReset}
    ${flexCenter}
    display: inline-flex;
    min-width: fit-content;
    text-decoration: inherit;

    ${({ gap }) => {
        return css`
            gap: ${typeof gap === "number" ? `${gap}px` : gap};
        `;
    }}
    img,
    svg {
        ${({ height, width, onClick }) => {
            return css`
                height: ${getSizeInRem(height)};
                width: ${getSizeInRem(width)};
                cursor: ${!!onClick ? "pointer" : "inherit"};
            `;
        }}
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        object-position: center;
        ${({ rotate }) =>
            rotate &&
            css`
                transform: rotate(${rotate});
            `}
    }

    ${({ svgFillColor }) =>
        svgFillColor
            ? css`
                  svg,
                  svg path {
                      fill: ${svgFillColor};
                  }
              `
            : ""}

    ${({ strokeColor }) =>
        strokeColor
            ? css`
                  svg,
                  svg path {
                      stroke: ${strokeColor};
                  }
              `
            : ""}
`;
